import {Suspense} from "react";
import {useSearchParams} from "react-router-dom";
import {ProductListing} from "@/components/shop/ProductListing";
import {useI18n} from "@/components/shop/I18nProvider";

function CautareInner() {
  const {t} = useI18n();
  const [params] = useSearchParams();
  const s = params.get("s") || "";
  if(!s.trim()) {
    return <div className="textZone"><p>{t("Search for products...")}</p></div>;
  }
  return <ProductListing params={{s}} title={`${t("Search results")}: ${s}`} />;
}

export function CautarePage() {
  return (
    <Suspense fallback={<div className="textZone"><p>...</p></div>}>
      <CautareInner />
    </Suspense>
  );
}
